import ConfigureCommunityMemberDialogContent from "./ConfigureCommunityMemberDialogContent";
import { Close, PersonAddAlt1Outlined } from '@mui/icons-material';
import { Dialog, DialogTitle, Grid2, IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { TariffsContextProvider } from 'contexts/tariffs/TariffsContext';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const ConfigureCommunityMemberDialog = ({ open, onClose, onSuccess, installation = null, fullScreen = true }) => {

    const { t } = useTranslation();

    const handleClose = () => {
        onClose();
    }

    return (
        <TariffsContextProvider>
            <Dialog open={open} fullScreen={fullScreen} maxWidth="xl" fullWidth={!fullScreen}>
                <DialogTitle>
                    <Grid2 container>
                        <Grid2 item size={{ xs: 9, sm: 6 }}>
                            <Stack spacing={2} direction="row" alignItems="center">
                                <IconButton onClick={handleClose}>
                                    <Close />
                                </IconButton>
                                <PersonAddAlt1Outlined color="primary" />
                                <Typography variant="subtitle1" color="textPrimary">{t("label.title.configureClient")}</Typography>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </DialogTitle>
                <ConfigureCommunityMemberDialogContent open={open} onClose={onClose} onSuccess={onSuccess} installation={installation} />
            </Dialog>
        </TariffsContextProvider>
    );
}

export default ConfigureCommunityMemberDialog;
